import axios from '../utils/axios';

const pathPrefix = `${process.env.REACT_APP_SERVER_URL}/api`;

export const importExcelAndSend = async (file: File, year: number): Promise<void> => {
  const formData = new FormData();
  formData.append('file', file);

  await axios.post(`${pathPrefix}/absentify/years/${year}/imports`, formData);
};

export const fetchLastUpdated = async (year: number): Promise<string> => {
  const url = `${pathPrefix}/absentify/last-updated?year=${year}`;
  const res = await axios.get(url);
  return res.data.updated;
};
